import { render, staticRenderFns } from "./vPagination.vue?vue&type=template&id=8b39c8be&scoped=true"
import script from "./vPagination.vue?vue&type=script&lang=js"
export * from "./vPagination.vue?vue&type=script&lang=js"
import style0 from "./vPagination.vue?vue&type=style&index=0&id=8b39c8be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b39c8be",
  null
  
)

export default component.exports